// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-header {
  position: fixed;
  width: 299px;
  height: 173px;
  opacity: 1;
  z-index: 10;
  overflow-x: hidden;
}
.book-cover {
  float: left;
  width: 91px;
  height: 118px;
  position: relative;
  left: 12px;
  top: 14px;
}
/* .book-title-container {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
} */
.book-title {
  height: 30px;
  font-size: 15px;
  font-weight: 600;
  line-height: 15px;
  opacity: 1;
  width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 30px;
  position: absolute;
  left: 30px;
  top: 20px;
  position: relative;
}
.book-arthur {
  height: 30px;
  font-size: 15px;
  line-height: 15px;
  opacity: 1;
  width: 150px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 30px;
  position: absolute;
  left: 30px;
  top: 10px;
  position: relative;
}

.reading-duration {
  position: absolute;
  left: 120px;
  top: 60px;
  font-size: 14px;
  line-height: 22px;
}

.book-content-title {
  line-height: 27px;
  opacity: 1;
  cursor: pointer;
  width: 23%;
  overflow-x: hidden;
  text-align: center;
  margin: 1% 1%;
}
.book-bookmark-title {
  line-height: 20px;
  opacity: 1;
  cursor: pointer;
  max-width: 25%;
  overflow-x: hidden;
  text-align: center;
  margin: 1% 1%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 5px;
}
.navigation-body-parent {
  position: absolute;
  top: 173px;
  overflow: hidden;
  width: 100%;
  height: calc(100% - 173px);
}
.navigation-body {
  width: 100%;
  height: 100%;

  overflow-y: scroll;
  z-index: 0;
  overflow-x: hidden;
}
.navigation-body:hover::-webkit-scrollbar-thumb,
.navigation-body:active::-webkit-scrollbar-thumb,
.navigation-body:focus::-webkit-scrollbar-thumb {
  display: block;
  width: 15px;
  border-radius: 0;
  opacity: 0.1;
  background-color: rgba(75, 75, 75, 0.2);
}
.navigation-body::-webkit-scrollbar-thumb {
  border-radius: 0px;
}
.navigation-body::-webkit-scrollbar {
  width: 15px;
}
.navigation-panel-empty-bookmark {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  line-height: 60px;
}
.navigation-navigation {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.navigation-panel {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 299px;
  height: 100%;
  opacity: 1;
  z-index: 10;
  animation: fade-left 0.2s ease-in-out 0s 1;
}
.navigation-search-box {
  position: absolute;
  left: 115px;
  top: 90px;
}
.navigation-search-title {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 44px);
  height: 38px;
  font-size: 15px;
  margin: 6px 22px;
  font-weight: 500;
}
.nav-close-icon {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 20px;
  transition: 0.1s;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-close-icon:hover {
  border-radius: 50%;
}
.nav-search-list {
  position: absolute;
  padding: 10px;
  top: 110px;
  font-size: 15px;
  height: calc(100vh - 170px);
  overflow-y: scroll;
  width: calc(100% - 20px);
}
.nav-search-list-item {
  padding: 8px;
  cursor: pointer;
  word-break: break-all;
  word-wrap: break-word;
}
.content-search-text {
  color: red !important;
  font-weight: 600 !important;
}
.nav-search-page {
  position: absolute;
  left: 40px;
  bottom: 7px;
  display: flex;
  justify-content: space-around;
  width: calc(100% - 80px);
  margin-top: 10px;
}
.nav-search-page-item {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
}
.nav-lock-icon {
  position: absolute;
  top: 0px;
  right: 0px;
  font-size: 20px;
  opacity: 0.3;
  margin: 10px;
  cursor: pointer;
  font-size: 20px;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/containers/panels/navigationPanel/navigationPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;;;;GAIG;AACH;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;;;EAGE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB","sourcesContent":[".navigation-header {\n  position: fixed;\n  width: 299px;\n  height: 173px;\n  opacity: 1;\n  z-index: 10;\n  overflow-x: hidden;\n}\n.book-cover {\n  float: left;\n  width: 91px;\n  height: 118px;\n  position: relative;\n  left: 12px;\n  top: 14px;\n}\n/* .book-title-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n} */\n.book-title {\n  height: 30px;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 15px;\n  opacity: 1;\n  width: 150px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  height: 30px;\n  position: absolute;\n  left: 30px;\n  top: 20px;\n  position: relative;\n}\n.book-arthur {\n  height: 30px;\n  font-size: 15px;\n  line-height: 15px;\n  opacity: 1;\n  width: 150px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  height: 30px;\n  position: absolute;\n  left: 30px;\n  top: 10px;\n  position: relative;\n}\n\n.reading-duration {\n  position: absolute;\n  left: 120px;\n  top: 60px;\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.book-content-title {\n  line-height: 27px;\n  opacity: 1;\n  cursor: pointer;\n  width: 23%;\n  overflow-x: hidden;\n  text-align: center;\n  margin: 1% 1%;\n}\n.book-bookmark-title {\n  line-height: 20px;\n  opacity: 1;\n  cursor: pointer;\n  max-width: 25%;\n  overflow-x: hidden;\n  text-align: center;\n  margin: 1% 1%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 5px;\n}\n.navigation-body-parent {\n  position: absolute;\n  top: 173px;\n  overflow: hidden;\n  width: 100%;\n  height: calc(100% - 173px);\n}\n.navigation-body {\n  width: 100%;\n  height: 100%;\n\n  overflow-y: scroll;\n  z-index: 0;\n  overflow-x: hidden;\n}\n.navigation-body:hover::-webkit-scrollbar-thumb,\n.navigation-body:active::-webkit-scrollbar-thumb,\n.navigation-body:focus::-webkit-scrollbar-thumb {\n  display: block;\n  width: 15px;\n  border-radius: 0;\n  opacity: 0.1;\n  background-color: rgba(75, 75, 75, 0.2);\n}\n.navigation-body::-webkit-scrollbar-thumb {\n  border-radius: 0px;\n}\n.navigation-body::-webkit-scrollbar {\n  width: 15px;\n}\n.navigation-panel-empty-bookmark {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 15px;\n  line-height: 60px;\n}\n.navigation-navigation {\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n}\n.navigation-panel {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 299px;\n  height: 100%;\n  opacity: 1;\n  z-index: 10;\n  animation: fade-left 0.2s ease-in-out 0s 1;\n}\n.navigation-search-box {\n  position: absolute;\n  left: 115px;\n  top: 90px;\n}\n.navigation-search-title {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 44px);\n  height: 38px;\n  font-size: 15px;\n  margin: 6px 22px;\n  font-weight: 500;\n}\n.nav-close-icon {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  font-size: 20px;\n  transition: 0.1s;\n  width: 38px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.nav-close-icon:hover {\n  border-radius: 50%;\n}\n.nav-search-list {\n  position: absolute;\n  padding: 10px;\n  top: 110px;\n  font-size: 15px;\n  height: calc(100vh - 170px);\n  overflow-y: scroll;\n  width: calc(100% - 20px);\n}\n.nav-search-list-item {\n  padding: 8px;\n  cursor: pointer;\n  word-break: break-all;\n  word-wrap: break-word;\n}\n.content-search-text {\n  color: red !important;\n  font-weight: 600 !important;\n}\n.nav-search-page {\n  position: absolute;\n  left: 40px;\n  bottom: 7px;\n  display: flex;\n  justify-content: space-around;\n  width: calc(100% - 80px);\n  margin-top: 10px;\n}\n.nav-search-page-item {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n.nav-lock-icon {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  font-size: 20px;\n  opacity: 0.3;\n  margin: 10px;\n  cursor: pointer;\n  font-size: 20px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
